import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import "./styles/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Datos considerados frescos por 10s → evita refetches redundantes
      // cuando varios componentes comparten la misma query en el mismo ciclo.
      staleTime: 10_000,
      // El salón necesita datos frescos; simulamos "tiempo real" con polling
      // hasta que se conecte el gateway Socket.IO (fase siguiente).
      // 10s en vez de 5s: reduce la carga a la mitad en tablets con Wi-Fi
      // inestable. Cada query crítica (mesas, domicilios) sigue teniendo su
      // propio intervalo más corto definido en su hook.
      refetchInterval: 10_000,
      // CRÍTICO para tablets: tocar la pantalla NO debe disparar refetches
      // extra — con la pantalla siempre activa esto generaba el doble de
      // peticiones y era la causa principal de congelamiento.
      refetchOnWindowFocus: false,
      // Un solo reintento con espera de 3s antes de mostrar error.
      // El default (3 reintentos) acumula 7 requests fallidos por cada error.
      retry: 1,
      retryDelay: 3000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
